import Location from '@/components/icons/Location';
import People from '@/components/icons/People';
import { useLivescoreMatch } from '@/context/LivescoreMatchContext';
import LivescoreMatchAd from '../LivescoreMatchAds/LivescoreMatchAds';
import Skeleton from '@/components/atoms/Skeleton/Skeleton';
import { SparklesIcon } from '@heroicons/react/24/solid';

const lorem =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

const LivescoreMatchDetails = () => {
  const { match, matchPreview } = useLivescoreMatch();

  return (
    <div className="text-black dark:text-white space-y-6">
      <div className="space-y-2">
        <p className="text-xxs font-semibold text-gray-400">ZAPOWIEDŹ</p>
        <div className="rounded-lg dark:bg-black-400 bg-white_theme-50 px-5 py-3.5">
          {matchPreview?.step === 'fetching' ? (
            <div className="space-y-4">
              <div className="space-y-2">
                <Skeleton className="w-full h-2" />
                <Skeleton className="w-2/3 h-2" />
                <Skeleton className="w-1/3 h-2" />
              </div>
              <div className="space-y-2">
                <Skeleton className="w-full h-2" />
                <Skeleton className="w-2/3 h-2" />
                <Skeleton className="w-1/3 h-2" />
              </div>
            </div>
          ) : matchPreview?.step === 'generating preview' ? (
            <div className="flex items-center gap-1 py-4 uppercase font-semibold w-full justify-center animate-pulse text-gray-400">
              <SparklesIcon className="w-5 h-5" />
              Wczytywanie Zapowiedzi
            </div>
          ) : matchPreview?.step === 'error' ? (
            <p className="text-center py-6 text-red-600 w-full font-medium text-xs uppercase">
              Nie udało się wygenerować zapowiedzi
            </p>
          ) : (
            <div className="space-y-2">
              {matchPreview?.preview?.preview.split('\n').map((p) => {
                if (p === '\n') {
                  return <br />;
                }

                return <p className="text-[11px]">{p}</p>;
              })}
            </div>
          )}
        </div>
      </div>
      {match.sport_event.venue && (
        <div className="space-y-2">
          <p className="text-xxs font-semibold text-gray-400">INFORMACJE O SPOTKANIU</p>
          <ul className="rounded-lg dark:bg-black-400 bg-white_theme-50 px-5 py-3.5 list-disc space-y-3">
            <li className="w-full flex items-center justify-between">
              <div className="flex items-center gap-2 text-[11px]">
                <Location /> Stadion
              </div>
              <p className="text-[11px] font-semibold">
                {match.sport_event.venue?.name} ({match.sport_event.venue?.city_name})
              </p>
            </li>

            <li className="w-full flex items-center justify-between">
              <div className="flex items-center gap-2 text-[11px]">
                <People /> Pojemność
              </div>
              <p className="text-[11px] font-semibold">{match.sport_event.venue?.capacity?.toLocaleString('pl-PL')}</p>
            </li>
          </ul>
        </div>
      )}
      <LivescoreMatchAd />
    </div>
  );
};

export default LivescoreMatchDetails;
